// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ImageDisplayModal_imageWrapper__UXhnJ"};